// extracted by mini-css-extract-plugin
module.exports = {"gauge":"AnalysisUnitsGauge_gauge__3OKXq","track":"AnalysisUnitsGauge_track__356Mh","fill":"AnalysisUnitsGauge_fill__2orps","tooltip":"AnalysisUnitsGauge_tooltip__1k9-e"};